





























































































































































































































































import { Component, Watch, Prop, Emit, Vue } from "vue-property-decorator";
import Sling from "@/classes/Sling";

@Component({
    components: {},
})
export default class SlingCanvas extends Vue {
    @Prop() readonly sling?: Sling;

    mounted() {}
}
